import React from 'react';
import { ImageConstants } from 'common/ImageConstants';
import { useLocalizedStrings } from 'i18n';
import { dashboardPath } from 'Routes';

import ErrorBasePage from './ErrorBasePage';

export const ErrorPage401: React.FunctionComponent = () => {
  const { t } = useLocalizedStrings();

  const goToDashboard = () => {
    window.location.href = dashboardPath;
  };

  return (
    <ErrorBasePage
      headerText={t('Errors.401Error.HeaderFirstLine')}
      detailsMessage={t('Errors.401Error.Details')}
      imageFileName={ImageConstants.ExclamationMark}
      primaryButton={{
        text: t('GoToHome'),
        onClick: goToDashboard,
      }}
    />
  );
};

export default ErrorPage401;
